import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil } from "@fortawesome/free-solid-svg-icons";
import { Form } from "react-bootstrap";
import Pagination_Holder from "../../../../../../common/common_components/pagination_holder/Pagination_Holder";
import { formatDate } from "../../../../../../utils/common";

const Complaint_Report_Table = ({
  setEdit,
  complaintsdetails,
  setCurrentPage,
  currentPage,
}) => {
  const data = complaintsdetails?.data || [];

  // const [currentPage, setCurrentPage] = useState(
  //   complaintsdetails?.current_page || 1,
  // );

  const perPage =
  complaintsdetails?.per_page || data?.length || 0;

  const totalPages = complaintsdetails?.total_pages || 1;

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <>
      <div className="common_table_container theme_bg">
        <div className="table-responsive">
          <table className="common_table table table-striped">
            <thead>
              <tr>
                <th>Sr.No</th>
                <th>Date</th>
                <th>Sample ID</th>
                <th>Customer Name</th>
                <th>Customer ID</th>
                <th>Contact No.</th>
                <th>Nature Of Complaint</th>
                <th>Remark</th>
                <th>Status</th>
              </tr>
            </thead>

            <tbody>
              {data.length > 0 ? (
                data.map((row, index) => (
                  <tr key={row.id || index}>
                    <td>{index + 1}</td>
                    {/* <td>
                      {row.updatedAt
                        ? new Date(row.updatedAt).toLocaleDateString("en-GB", {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                          })
                        : "---"}
                    </td> */}
                    <td>{formatDate(row.createdAt) || "-"}</td>

                    <td>{row.Sample_Management?.unique_id || "---"}</td>

                    <td>{row.customer_name || "---"}</td>

                    <td>{row.User?.name || "---"}</td>

                    <td>{row.contact_person_contact_no || "---"}</td>

                    <td>{row.Nature_Of_Complaint?.name || "---"}</td>

                    <td>{row.remark || "---"}</td>

                    <td
                      className={
                        row.Complaint_Status?.name === "Pending"
                          ? "status_pending"
                          : "status_completed"
                      }
                    >
                      {row.Complaint_Status?.name || "---"}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="9" className="text-center">
                    No Complaints Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      <div className="comon_page_footer">
        <div className="show_entry_div">
          <p className="show_text">
            Showing {data.length} of {complaintsdetails?.total || 0} Entries
          </p>
        </div>

        <div className="pagination_div">
          <Pagination_Holder
            onPageChange={currentPage}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
          />
        </div>
      </div>
    </>
  );
};

export default Complaint_Report_Table;
